module.exports = "<p class=\"<%= gwTileHeaderIcon %>\">\n    <i class=\"fa\" ng-class=\"icon\"></i>\n</p>"